module.exports = __webpack_public_path__ + "static/window-cleaning-edmonton-hero-ca0c44fc744e46fb70a5537e416d94e9.jpg";